import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  LayoutDashboard, Users, Package, CreditCard, Layers, Film,
  MapPin, Building2, Settings as SettingsIcon, LogOut, MessageCircle, UserX, Contact, ArrowRightLeft, Tags, ReceiptIndianRupee,
} from "lucide-react";import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Header";
import { Badge } from "@/components/ui/badge";

const NAV = [
  ["", "Dashboard", LayoutDashboard],
  ["sellers", "All Sellers", Users],
  ["incomplete-signups", "Incomplete Signups", UserX],
  ["leads", "Leads CRM", ArrowRightLeft],
  ["subscriptions", "Subscriptions", Layers],
  ["packages", "Package Planner", Layers],
  ["products", "Products", Package],
  ["sales-log", "Sales Log", ReceiptIndianRupee],
  ["categories", "Product Options", Tags],
  ["media", "Media Assets", Film],
  ["clicks", "Clicks History", MessageCircle],
  ["visitors", "Visitor Directory", Contact],
  ["payments", "Payments", CreditCard],
  ["cities", "Cities", MapPin],
  ["localities", "Localities", Building2],
  ["settings", "Payment QR Settings", SettingsIcon],
];

export default function AdminLayout() {
  const nav = useNavigate();
  const { logout } = useAuth();
  const [badges, setBadges] = useState({ incomplete_no_payment: 0, pending_payments: 0 });
  useEffect(() => {
    const fetchBadges = () => api.get("/admin/nav-badges").then(({ data }) => setBadges(data)).catch(() => {});
    fetchBadges();
    const t = setInterval(fetchBadges, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="min-h-screen bg-secondary/30 flex">
      <aside className="w-64 bg-slate-900 text-white flex-col hidden lg:flex sticky top-0 h-screen">
        <div className="p-5 border-b border-white/10 flex items-center justify-between">
          <Logo onClick={() => nav("/")} dark />
        </div>
        <div className="px-5 py-3 border-b border-white/10"><Badge className="bg-rose-500/20 text-rose-300 border-rose-500/30 font-bold">Admin Console</Badge></div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto ct-scroll">
          {NAV.map(([path, label, Icon]) => (
            <NavLink key={path} to={path === "" ? "/admin" : `/admin/${path}`} end={path === ""}
              data-testid={`admin-nav-${path || "dashboard"}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold transition-colors ${isActive ? "bg-primary text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`}>
              <Icon className="h-4 w-4" /> <span>{label}</span>
              {path === "incomplete-signups" && badges.incomplete_no_payment > 0 && (
                <span data-testid="incomplete-badge" className="ml-auto min-w-[20px] h-5 px-1.5 grid place-items-center rounded-full bg-rose-500 text-white text-[11px] font-bold">{badges.incomplete_no_payment}</span>
              )}
              {path === "payments" && badges.pending_payments > 0 && (
                <span data-testid="pending-payments-badge" className="ml-auto min-w-[20px] h-5 px-1.5 grid place-items-center rounded-full bg-amber-500 text-white text-[11px] font-bold">{badges.pending_payments}</span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button data-testid="admin-logout" onClick={() => { logout(); nav("/"); }} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-white/60 hover:text-white hover:bg-white/5"><LogOut className="h-4 w-4" /> Logout</button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-0 z-30 bg-slate-900 text-white p-3 flex items-center justify-between">
          <Logo onClick={() => nav("/")} dark />
          <button onClick={() => { logout(); nav("/"); }}><LogOut className="h-5 w-5" /></button>
        </div>
        <div className="lg:hidden flex gap-1 overflow-x-auto ct-scroll bg-slate-800 p-2">
          {NAV.map(([path, label]) => (
            <NavLink key={path} to={path === "" ? "/admin" : `/admin/${path}`} end={path === ""}
              className={({ isActive }) => `whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-semibold ${isActive ? "bg-primary text-white" : "bg-white/10 text-white/70"}`}>{label}</NavLink>
          ))}
        </div>
        <div className="p-4 sm:p-6 lg:p-8 max-w-[1300px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
